// What the studio preview is made of: the product's logo, and the ink that
// reads on a brand colour.

const BASE = `${process.env.PUBLIC_URL}/home/studios`;

// The logo the lower third carries until the advisor adds their own.
export const LOGO_SRC = `${BASE}/avrah-mark.webp`;

const HEX = /^#[0-9a-f]{6}$/i;

// WCAG 2 relative luminance of a #RRGGBB colour.
const luminance = (hex) => {
  if (!HEX.test(hex)) throw new Error(`"${hex}" is not a #RRGGBB colour`);
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

export const contrast = (a, b) => {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
};

const INKS = ["#121214", "#ffffff"];

// The text colour for words on a brand colour: near-black or white,
// whichever reads better, as the product's title band does.
export const inkOn = (hex) => (contrast(hex, INKS[0]) >= contrast(hex, INKS[1]) ? INKS[0] : INKS[1]);
